module.exports = __webpack_public_path__ + "img/all_test_link.a351c220.svg";